
import './App.css';
import React, { useEffect } from "react";
import Header from './Header';
import Home from './Home';
import{BrowserRouter as Router,Switch,Route} from "react-router-dom"
import Checkout from './Checkout';
import Subheader from './Subheader';
import Mobiles from './Mobiles';
import Login from './Login';
import Payment from './Payment';
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Prime from './Prime';
import Electronics from './Electronics';
import Fashion from './Fashion';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from './Orders';

const promise = loadStripe(
  "pk_test_51JshVqSI8g1uI8aCfuU3vvvI20pONaKJIlk1GHNMugT6gBMlxICkJutLXOaLwq9SunwEef5qZCfEKSxZYDvCBgp600iTnMJxmH"
);


function App() {
  const [{}, dispatch] = useStateValue();
  useEffect(() => {
    // will only run once when the app component loads...

    auth.onAuthStateChanged((authUser) => {
      console.log("THE USER IS >>> ", authUser);

      if (authUser) {
        // the user just logged in / the user was logged in

        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);
  return (
    <Router>
    <div className="App">
      <Switch>
        <Route path='/login'>
          <Login/>
          </Route>
          <Route path='/orders'>
          <Header/>
      <Subheader/>
          <Orders/>
          </Route>
          <Route path='/prime'>
          <Header/>
      <Subheader/>
          <Prime/>
          </Route>
          <Route path='/electronics'>
          <Header/>
      <Subheader/>
          <Electronics/>
          </Route>
          <Route path='/fashion'>
          <Header/>
      <Subheader/>
          <Fashion/>
          </Route>
      <Route path='/checkout'>
      <Header/>
      <Subheader/>
      <Checkout/>
            </Route>
            <Route path='/payment'>
     <Header/>
     <Elements stripe={promise}>
     <Payment />
     </Elements>
            </Route>

            <Route path='/mobiles'>
      <Header/>
      <Subheader/>
      <Mobiles/>
            </Route>
        <Route path='/'>
           <Header/>
           <Subheader/>
          <Home/>
      </Route>
     
      </Switch>
    </div>
    </Router>
  );
}

export default App;
